<template>
	<v-col class="history-bonus">
		<DetailBonusUnilevel ref="detailBonusUnilevel"></DetailBonusUnilevel>
		<div class="d-flex justify-space-between">
			<div class="text-h5 cl-primary">Histori Komisi</div>
		</div>
		<div class="pt-1 pb-2 d-flex font-size-10 grey--text">
			<v-icon small color="grey">mdi-database</v-icon>
			<div class="pl-2">Komisi</div>
			<div class="px-2">/</div>
			<div>Histori Komisi</div>
		</div>
		<div class="mt-5">
			<v-row justify="end">
				<v-col cols="12" sm="11" md="8" class="py-0 py-sm-3">
					<v-row justify="end">
						<v-col cols="12" sm="12" md="4">
							<v-menu v-model="startDate" :close-on-content-click="false" :nudge-right="0" transition="scale-transition" offset-y min-width="290px">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field placeholder="Pilih Bulan" outlined dense append-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" background-color="white" class="rounded-lg date-no-border" hide-details :value="convertMonth(dateStart)"></v-text-field>
								</template>
								<v-date-picker locale="id" type="month" first-day-of-week="0" color="primary" :max="today" @input="startDate = false" @change="changeDate" v-model="dateStart"></v-date-picker>
							</v-menu>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12" class="pb-1">
					<v-card class="pa-3 elevation-0 rounded-lg hover-shadow">
						<v-tabs class="tabs-vo no-slider">
							<v-tab @click="changeWeek(1)">Minggu ke 1</v-tab>
							<v-tab @click="changeWeek(2)">Minggu ke 2</v-tab>
							<v-tab @click="changeWeek(3)">Minggu ke 3</v-tab>
							<v-tab @click="changeWeek(4)">Minggu ke 4</v-tab>
						</v-tabs>
					</v-card>
				</v-col>
			</v-row>
			<div class="mt-3" v-if="!loading">
				<v-row v-if="listHistoryBonus.length > 0">
					<v-col cols="12" class="pt-0 d-none d-md-block">
						<v-simple-table class="white-row table-vo table-history-bonus">
							<template v-slot:default>
								<thead class="">
									<tr>
										<th class="text-left">Hari</th>
										<th class="text-left">Tanggal</th>
										<th class="text-right">Pasangan(Rp)</th>
										<th class="text-right">Sponsor(Rp)</th>
										<th class="text-right">Unilevel(Rp)</th>
										<th class="text-center">Total(Rp)</th>
									</tr>
								</thead>
								<tbody class="grey--text text--darken-3">
									<tr v-for="bonus in listHistoryBonus" :key="bonus.bonus_log_id">
										<td>{{ bonus.bonus_log_date | hari }}</td>
										<td>{{ bonus.bonus_log_date | tanggal }}</td>
										<td class="text-right">{{ bonus.bonus_log_match | toNumber }}</td>
										<td class="text-right">{{ bonus.bonus_log_sponsor | toNumber }}</td>
										<td class="text-right">{{ bonus.bonus_log_unilevel | toNumber }}</td>
										<td class="text-center">
											<div class="px-1 py-2 bg-primary-light cl-secondary font-weight-500 rounded-pill">{{ parseInt(bonus.bonus_log_match) + parseInt(bonus.bonus_log_sponsor) + parseInt(bonus.bonus_log_unilevel) | toNumber }}</div>
										</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</v-col>

					<v-col cols="12" class="pt-0 d-block d-md-none">
						<v-card elevation="1" class="hover-shadow pa-4" v-for="bonus in listHistoryBonus" :key="bonus.bonus_log_id">
							<div class="d-flex align-center justify-start font-size-10 mb-4">
								<span class="d-flex align-center black--text font-weight-500"><v-icon dense class="mr-2">mdi-calendar-outline</v-icon>{{ bonus.bonus_log_date | hari }}, {{ bonus.bonus_log_date | tanggal }}</span>
							</div>

							<div class="d-flex align-center justify-space-between font-size-10 mb-1">
								<span class="cl-secondary">Pasangan (Rp)</span>
								<span class="cl-primary font-weight-500">{{ bonus.bonus_log_match | toNumber }}</span>
							</div>

							<div class="d-flex align-center justify-space-between font-size-10 mb-1">
								<span class="cl-secondary">Sponsor (Rp)</span>
								<span class="cl-primary font-weight-500">{{ bonus.bonus_log_sponsor | toNumber }}</span>
							</div>

							<div class="d-flex align-center justify-space-between font-size-10 mb-1">
								<span class="cl-secondary">Unilevel (Rp)</span>
								<span class="cl-primary font-weight-500">{{ bonus.bonus_log_unilevel | toNumber }}</span>
							</div>

							<div class="d-flex align-center justify-space-between font-size-11 mt-5">
								<span class="cl-secondary font-weight-600">Total (Rp)</span>
								<span class="cl-primary font-weight-600">{{ parseInt(bonus.bonus_log_match) + parseInt(bonus.bonus_log_sponsor) + parseInt(bonus.bonus_log_unilevel) | toNumber }}</span>
							</div>
						</v-card>
					</v-col>
				</v-row>
				<div class="mt-5" v-if="listHistoryBonus.length == 0">
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-card class="py-3 elevation-0 hover-shadow rounded-lg">
								<NoData></NoData>
								<div class="pt-3 text-center cl-secondary">Tidak ada data histori komisi yang dapat ditampilkan</div>
							</v-card>
						</v-col>
					</v-row>
				</div>
			</div>
			<div class="mt-4" v-if="loading">
				<v-row>
					<v-col cols="12" sm="12" md="12">
						<LoadData :loading="loading"></LoadData>
					</v-col>
				</v-row>
			</div>
		</div>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import DetailBonusUnilevel from './components/DetailBonusUnilevel';

export default {
	components: {
		DetailBonusUnilevel
	},
	data() {
		return {
			loading: false,
			startDate: false,
			dateStart: moment().format("YYYY-MM"),
			start: '',
			end: '',
			monthYear: new Date().getFullYear() + '-' + (new Date().getMonth() + 1),
			dayStart: '1',
			dayEnd: '7',
			totalArray: [],
			activeWeek: 1
		}
	},
	computed: {
		...mapState('bonus', ['listHistoryBonus', 'historyBonusPagination']),
	},
	methods: {
		...mapActions('bonus', ['getHistoryBonus']),

		showDetailUnilevel() {
			this.$refs.detailBonusUnilevel.modalShow()
		},
		async changeDate() {
			await this.changeWeek(this.activeWeek)
			this.getData()
		},
		changeWeek(week) {
			if (week == 1) {
				this.dayStart = '1'
				this.dayEnd = '7'
				this.getData()
			}
			if (week == 2) {
				this.dayStart = '8'
				this.dayEnd = '14'
				this.getData()
			}
			if (week == 3) {
				this.dayStart = '15'
				this.dayEnd = '21'
				this.getData()
			}
			if (week == 4) {
				this.dayStart = '22'
				this.dayEnd = '31'
				this.getData()
			}

			this.activeWeek = week
		},
		getData() {
			this.loading = true
			if (this.dateStart) {
				this.start = this.dateStart + '-' + this.dayStart
				this.end = this.dateStart + '-' + this.dayEnd
			} else {
				this.start = this.monthYear + '-' + this.dayStart
				this.end = this.monthYear + '-' + this.dayEnd
			}
			this.getHistoryBonus({ start: this.start, end: this.end, sort: 'bonus_log_id', dir: 'ASC' }).then(() => {
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
				this.loading = false
			})
		},
		total() {
			let sponsor = 0
			let match = 0
			let genSponsor = 0
			let genMatch = 0
			this.listHistoryBonus.forEach((el) => {
				sponsor += parseInt(el.bonus_log_sponsor)
				match += parseInt(el.bonus_log_match)
				genSponsor += parseInt(el.bonus_log_gen_sponsor)
				genMatch += parseInt(el.bonus_log_gen_match)
			})
			this.totalArray.push(sponsor, match, genMatch, genSponsor)
		}
	},
	created() {
		this.$store.dispatch('setPageTitle', `Histori Komisi`)
		this.getData()
	}
};
</script>

